import React from 'react';

export const errorHandler = (error, errorInfo) => {
  console.log(
    '%cOne Error ocurred',
    'color: red; font-family:monospace; font-size: 16px; background-color: #222',
    error,
    errorInfo
  );
};

const BuzzFallback = () => {
  return <h1>Internal Error</h1>;
};

export default BuzzFallback;
